import { render, staticRenderFns } from "./DesktopClientDashboard.vue?vue&type=template&id=390c3dc2&scoped=true&"
import script from "./DesktopClientDashboard.vue?vue&type=script&lang=js&"
export * from "./DesktopClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DesktopClientDashboard.vue?vue&type=style&index=0&id=390c3dc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c3dc2",
  null
  
)

export default component.exports